import { useEffect, useState, useCallback } from "react";
import { fetchData } from "../../utils/apiUtils";
import Spinner from "../../Components/spinner";
import { useNavigate, useParams } from "react-router-dom";
import debounce from "lodash.debounce";
import CustomPagination from "../../helper/Pagination";
import dateformate from "../../helper/DateFormate";
import StatusBadge from "../../Components/StatusBadge";
import { ViewButton } from "../../helper/ImageFormat";

const UserOrder = () => {
 const { id } = useParams();
 const navigator = useNavigate();
 const [loading, setLoading] = useState(true);
 const [customerorderdata, setCustomerOrderData] = useState([]);
 const [totalCount, setTotalCount] = useState(0);
 const [currentPage, setCurrentPage] = useState(1);
 const perPage = 10;
 const [search, setSearch] = useState("");
 const [startDate, setStartDate] = useState("");
 const [endDate, setEndDate] = useState("");
 const [paymentStatus, setPaymentStatus] = useState("");
 const [orderStatus, setOrderStatus] = useState("");

 const totalPages = Math.ceil(totalCount / perPage);

 const fetchCustomerOrderData = async (page = 1, searchQuery = "") => {
  setLoading(true);
  const requestData = {
   perPage,
   pageNo: page,
   search: searchQuery,
   userId: id,
   startDate,
   endDate,
   paymentStatus,
   orderStatus,
  };

  await fetchData(
   "customer/order/history",
   requestData,
   setCustomerOrderData,
   setTotalCount,
   setCurrentPage,
   setLoading
  );
 };

 const debouncedFetchCustomers = useCallback(
  debounce(fetchCustomerOrderData, 500),
  [perPage, startDate, endDate, paymentStatus, orderStatus]
 );

 useEffect(() => {
  debouncedFetchCustomers(1, search);
 }, [search, perPage, startDate, endDate, paymentStatus, orderStatus]);

 const handlePageClick = (page) => {
  if (page >= 1 && page <= totalPages) {
   debouncedFetchCustomers(page, search);
  }
 };
 const handleRedirect = (item) => {
  navigator(`/order/detail/${item?.orderId}`);
 };

 return (
  <div className="content-wrapper mb-5">
   <div className="page-header mt-5">
    <h3 className="custom-page-title">Orders</h3>
   </div>

   <div className="filters card p-4 mb-4 shadow-sm border-radius-10">
    <div className="row align-items-center">
     <div className="col-md-4 mb-3">
      <label className="form-label">Start Date</label>
      <input
       type="date"
       className="form-control border border-dark"
       value={startDate}
       onChange={(e) => setStartDate(e.target.value)}
      />
     </div>

     <div className="col-md-4 mb-3">
      <label className="form-label">End Date</label>
      <input
       type="date"
       className="form-control border border-dark"
       value={endDate}
       onChange={(e) => setEndDate(e.target.value)}
      />
     </div>

     <div className="col-md-4 mb-3">
      <label className="form-label">Payment Status</label>
      <select
       className="form-control"
       value={paymentStatus}
       onChange={(e) => setPaymentStatus(e.target.value)}
      >
       <option value="">All</option>
       <option value="SUCCESS">Successful</option>
       <option value="CANCELLED">Cancelled</option>
       <option value="PENDING">Pending</option>
       <option value="PROCESSING">Processing</option>
       <option value="REFUNDED">Refunded</option>
      </select>
     </div>

     <div className="col-md-4 mb-3">
      <label className="form-label">Order Status</label>
      <select
       className="form-control"
       value={orderStatus}
       onChange={(e) => setOrderStatus(e.target.value)}
      >
       <option value="">All</option>
       <option value="PENDING">Pending</option>
       <option value="PROCESSING">Processing</option>
       <option value="DELIVERED">Delivered</option>
       <option value="CANCELLED">Cancelled</option>
       <option value="PARTIALLY_DELIVERED">Partially Delivered</option>
      </select>
     </div>

     <div className="col-md-4 mt-2">
      <input
       type="text"
       className="form-control border border-dark"
       placeholder="Search through Orderid"
       onChange={(e) => setSearch(e.target.value)}
      />
     </div>

     {/* <div className="col-md-4 mb-3">
            <Button color="primary" onClick={handleExportToExcel}>
              <i className="fas fa-file-excel mr-2"></i> Export to Excel
            </Button>
          </div> */}
    </div>
   </div>

   <div className="row">
    <div className="col-md-12 grid-margin stretch-card">
     <div className="card">
      <div className="card-body">
       <div className="table-responsive">
        <table className="custom-table table table-striped">
         <thead>
          <tr>
           {[
            "OrderId",
            "Order Date",
            "User Name",
            "Items",
            "Type",
            "Order Status",
            "Payment Method",
            "Payment Status",
            "View",
           ].map((head, i) => (
            <th className="text-left" key={i}>
             {head}
            </th>
           ))}
          </tr>
         </thead>
         <tbody>
          {loading ? (
           <tr>
            <td colSpan="10" className="text-center">
             <Spinner />
            </td>
           </tr>
          ) : customerorderdata && customerorderdata?.length > 0 ? (
           customerorderdata?.map((item, index) => (
            <tr key={index}>
             <td>{item?.orderId}</td>
             <td>{dateformate(item?.createdAt)}</td>

             <td>{item?.user?.name}</td>

             <td>{item?.orderItemCount}</td>
             <td>
              {item?.type === "product" && (
               <span className="badge bg-dark text-white p-1">Product</span>
              )}
              {item?.type === "catalogue" && (
               <span className="badge bg-dark text-white p-1">Catalogue</span>
              )}
             </td>

             <td>
              <StatusBadge status={item?.status} />
             </td>

             <td>
              <StatusBadge status={item?.payment?.status} />
             </td>

             <td>{item?.payment?.paymentMethod}</td>

             <td>
              <ViewButton
               handleRedirect={() => {
                handleRedirect(item);
               }}
               id={item?.order?.orderId}
              />
             </td>
            </tr>
           ))
          ) : (
           <tr>
            <td colSpan="10" className="text-center">
             <h5>No data found.</h5>
            </td>
           </tr>
          )}
         </tbody>
        </table>

        {customerorderdata && customerorderdata?.length > 0 && (
         <CustomPagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageClick}
          perPage={perPage}
          totalCount={totalCount}
         />
        )}
       </div>
      </div>
     </div>
    </div>
   </div>
  </div>
 );
};

export default UserOrder;
